module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"roles":{"owner":"创建者","admin":"管理员","member":"普通成员"},"memberState":{"accepted":"正常","awaiting":"未激活","denied":"已拒绝"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/members/details/index.vue
// module id = 336
// module chunks = 3